import type { GuestList as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as GuestListEntry from './GuestListEntry';
import * as GuestListImport from './GuestListImport';

/** An event's door list of named guests — one row of the Tickets tab's Guest lists section. */
export type GuestList = {
  id: number;
  eventId: number;
  /** Null on lists created before names were required. */
  name: string | null;
  /** Read-only: the sum of the entries' quantities. */
  allotment: number;
  /** Read-only. */
  claimed: number;
  entries: GuestListEntry.GuestListEntry[];
  latestImport: GuestListImport.GuestListImport | null;
};

export const fromGql = (item: GQLItem): GuestList => ({
  ...take<GuestList>(item, 'id', 'eventId', 'name', 'allotment', 'claimed'),
  entries: item.entries.map(GuestListEntry.fromGql),
  latestImport: item.importExport ? GuestListImport.fromGql(item.importExport) : null,
});
